import { CursorPaginationParametersRequest } from '@/modules/common';
import { PaginatedMetadataResponse } from '@/types/generated';

export enum TimeOffRequestSummaryStatusDTO {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
}

export enum TimeOffRequestStatusDTO {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
}

export interface TimeOffSummaryItemResponse {
  status: TimeOffRequestSummaryStatusDTO;
  totalMinutes: number;
}

export interface TimeOffDaySummaryItemResponse {
  date: string;
  status: TimeOffRequestSummaryStatusDTO;
  totalMinutes: number;
}

export interface TimeOffDaysPageResponse {
  items: TimeOffDaySummaryItemResponse[];
  pagination: PaginatedMetadataResponse;
}

export interface GetTimeOffDaysSummaryRequest {
  startDate: string;
  endDate: string;
  statuses: TimeOffRequestStatusDTO[];
  pageSize: number;
  pagination: CursorPaginationParametersRequest<string>;
}
